var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.handleResize),expression:"handleResize"}],staticClass:"overlay",class:{active: _vm.isShown && !_vm.resolutionBan},on:{"click":function($event){return _vm.$emit('close')}}})}
var staticRenderFns = []

export { render, staticRenderFns }